import React from "react";

class NotFound extends React.Component{
    componentDidMount(){
      document.title = 'AnXiens'
  }
    render(){
      return (
          <div>
              <h1 style={{"color":"white"}}>404-The Page Not Found</h1>
          </div>
        )
      }
  }
  
    export default NotFound